module.exports = __webpack_public_path__ + "static/img_4749-8c278466b5424dba24cccb902ecfdf91.webp";